__turbopack_context__.v({
  "learning_media_badge": "MXny4G_learning_media_badge",
  "learning_media_badge__button": "MXny4G_learning_media_badge__button",
  "learning_media_badge__copy_long": "MXny4G_learning_media_badge__copy_long",
  "learning_media_badge__copy_short": "MXny4G_learning_media_badge__copy_short",
});
